export default (id, field) => {
    return `[${id}].${field}Visible`
}
